import { PopoverPlacement, PopoverTriggerType } from "@idui/react-popover";
import { FC } from "react";
import { useRecoilValue } from "recoil";

import { PIC } from "@ryde/assets";
import { usePageContext, useRtl } from "@ryde/redux";
import {
  SortingEnum,
  tableColumnSortingValueSF,
  tableGroupingAF,
} from "@ryde/shared";
import { greyMui } from "@ryde/theme";

import { HeaderPopover, IHeaderPopover } from "../context-panels";
import {
  HeaderCellSortableButtonWrapper,
  HeaderCelSortablePopover,
} from "./header.cell.styled";

export const HeaderCellSortable: FC<IHeaderPopover> = props => {
  const { fieldNameResolved, children } = props;
  const { isRtl } = useRtl();
  const { entity } = usePageContext();
  const sorting = useRecoilValue(
    tableColumnSortingValueSF([entity, fieldNameResolved]),
  );
  const grouping = useRecoilValue(tableGroupingAF(entity));
  const isGroupingCurrentField = grouping.includes(fieldNameResolved);

  return (
    <HeaderCellSortableButtonWrapper>
      <span className="th_sortable_content">
        <button
          className="header_sortable_button"
          data-e2e="sorting-button-popover"
          data-e2e-id={`${fieldNameResolved}`}
          data-e2e-value={`sorting_${sorting}`}
        >
          <HeaderCelSortablePopover
            content={<HeaderPopover {...props} />}
            trigger={PopoverTriggerType.hover}
            closeOnRemoteClick
            mouseEnterDelay={300}
            mouseLeaveDelay={100}
            withArrow={false}
            placement={
              isRtl ? PopoverPlacement.topRight : PopoverPlacement.topLeft
            }
            guessBetterPosition
          >
            <span className="th_sortable_popover-wrapper">
              <span className="th_sortable_text_wrapper">{children}</span>

              {sorting === SortingEnum.Asc && (
                <PIC.TableSortAscSVG data-e2e="sort-asc" />
              )}
              {sorting === SortingEnum.Desc && (
                <PIC.TableSortDescSVG data-e2e="sort-desc" />
              )}
              {isGroupingCurrentField && (
                <PIC.TableGroupSVG
                  color={greyMui._700}
                  data-e2e="svg-group-by"
                />
              )}
            </span>
          </HeaderCelSortablePopover>
        </button>
      </span>
    </HeaderCellSortableButtonWrapper>
  );
};
